import { render, staticRenderFns } from "./signature-2.vue?vue&type=template&id=dfc6e460&"
import script from "./signature-2.vue?vue&type=script&lang=js&"
export * from "./signature-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports